import React from 'react';
import './cancel-shipment-button.css';

export default function CancelShipmentButton({ children = 'Seferi İptal Et', className = '', ...props }) {
  return <button type="button" {...props} className={`cimento-cancel-button ${className}`.trim()}>
    <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true"><circle cx="12" cy="12" r="8.5" /><path d="m6 6 12 12" /></svg>
    <span>{children}</span>
  </button>;
}
